import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import '@/assets/scss/ds/global.scss';
import VueThemeManager from '@descomplica/vue-theme-manager';
import VueCookies from 'vue-cookies';
import VueAnalytics from 'vue-analytics';
import SentryClient from './helpers/sentry';
import { initMixpanel } from './helpers/analytics/mixpanel';

Vue.use(VueCookies);

declare module 'vue/types/vue' {
  interface Vue {
    $AppTheme: typeof VueThemeManager;
  }
}

Vue.config.productionTip = false;

const areTrackingsEnabled = JSON.parse(process.env.VUE_APP_ENABLE_TRACKINGS || 'false');

if (areTrackingsEnabled) {
  // antes do Pocket (que é `defer`): o GTM que ele carrega já encontra o `window.mixpanel`
  initMixpanel(process.env.VUE_APP_MIXPANEL_TOKEN);

  // sem `mixpanel`: o Pocket não carrega nem envia mais nada ao Mixpanel
  window.POCKET_ENV = {
    hubspot: process.env.VUE_APP_HUBSPOT_ID,
    gtm: process.env.VUE_APP_GTM_TOKEN,
  };

  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA_TOKEN,
    autoTracking: {
      page: false,
      pageviewOnLoad: false,
    },
  });
}

SentryClient.enableSentry();

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
